import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { AtlasUserModel } from '../tasks/model/tasks'
import {
  AtlasAccessDetailFilterModel,
  AtlasAccessDetailModel,
  AtlasAccessKpiModel,
  AtlasAccessSearchFilterModel,
  AtlasAccessTableModel
} from './model/atlasAccess'

export const apiSearchAtlasAccess = async (
  request: AtlasAccessSearchFilterModel
): Promise<AtlasAccessTableModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.post(`${apiSuffixUrl}/api/Atlas/Access/Search`, request).then(
    response => response.data
  )
}

export const apiGetAtlasAccessKpis = async (): Promise<AtlasAccessKpiModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Atlas/GetAtlasAccessKpis`).then(
    response => response.data
  )
}

export const apiGetAtlasAccessTable = async (): Promise<AtlasAccessTableModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Atlas/GetAtlasAccessTable`).then(
    response => response.data
  )
}

export const apiGetAtlasAccessDetail = async (
  request: AtlasAccessDetailFilterModel
): Promise<AtlasAccessDetailModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Atlas/GetAtlasAccessDetail`, {
    params: { entityId: request.entityId, entityType: request.entityType }
  }).then(response => response.data)
}

export const apiSearchAtlasUsers = async (searchText: string): Promise<AtlasUserModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Atlas/SearchUsuarioAtlas`, {
    params: { searchText }
  }).then(response => response.data ?? [])
}

export const apiGetAtlasSuperUsers = async (): Promise<AtlasUserModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.get(`${apiSuffixUrl}/api/Atlas/GetAtlasSuperUsers`).then(
    response => response.data ?? []
  )
}

// añade o quita el permiso de superusuario (204 sin contenido)
export const apiSetAtlasSuperUser = async (
  idUsuarioAtlas: number,
  superUser: boolean
): Promise<void> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.patch(`${apiSuffixUrl}/api/Atlas/SetSuperUser`, null, {
    params: { idUsuarioAtlas, superUser }
  }).then(() => undefined)
}

// da de baja al usuario atlas - también le quita el permiso de superusuario (204 sin contenido)
export const apiDeactivateUsuarioAtlas = async (idUsuarioAtlas: number): Promise<void> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.patch(`${apiSuffixUrl}/api/Atlas/DeactivateUsuarioAtlas`, null, {
    params: { idUsuarioAtlas }
  }).then(() => undefined)
}
